import { request } from '@/shared/api/http'
import type { TelegramUser } from '@/shared/lib/telegram'
import type {
  LoginResult, MessageResponse, ResetTokenResponse, TokenResponse,
} from '@/shared/api/types'

/**
 * Вход и восстановление доступа. Все ручки анонимные: токена ещё нет.
 */
export const auth = {
  /** Может вернуть токен, а может — требование второго фактора. */
  login(email: string, password: string) {
    return request<LoginResult>('/auth/login', {
      method: 'POST', body: { email, password }, anonymous: true,
    })
  },

  /** Вход по данным Telegram Login. Подпись проверяет бекенд токеном бота. */
  telegram(user: TelegramUser) {
    return request<LoginResult>('/auth/telegram', {
      method: 'POST', body: user, anonymous: true,
    })
  },

  /** Второй фактор: TOTP из приложения либо резервный код ABCD-1234. */
  twoFactor(token: string, code: string) {
    return request<TokenResponse>('/auth/2fa', {
      method: 'POST', body: { '2fa_token': token, code }, anonymous: true,
    })
  },

  requestReset(email: string) {
    return request<MessageResponse>('/auth/password-reset/request', {
      method: 'POST', body: { email }, anonymous: true,
    })
  },

  /** Код с почты в обмен на разовый токен смены пароля. */
  confirmReset(email: string, code: string) {
    return request<ResetTokenResponse>('/auth/password-reset/confirm', {
      method: 'POST', body: { email, code }, anonymous: true,
    })
  },

  completeReset(resetToken: string, password: string) {
    return request<MessageResponse>('/auth/password-reset/complete', {
      method: 'POST', body: { reset_token: resetToken, password }, anonymous: true,
    })
  },
}
